import Vue from 'vue'
import VueRouter from 'vue-router'
import { isAdminLoggedIn } from '@/utils/auth'
import Login from '../views/Login.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import CategoryManagement from '../views/CategoryManagement.vue'
import ResourceManagement from '../views/ResourceManagement.vue'
import HomeImageManagement from '../views/HomeImageManagement.vue'
import BatchResourceUpload from '../views/BatchResourceUpload.vue'
import ConfigManagement from '../views/ConfigManagement.vue'
import ChangePassword from '../views/ChangePassword.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/categories',
    name: 'CategoryManagement',
    component: CategoryManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/resources',
    name: 'ResourceManagement',
    component: ResourceManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/resources/batch-upload',
    name: 'BatchResourceUpload',
    component: BatchResourceUpload,
    meta: { requiresAuth: true }
  },
  {
    path: '/home-images',
    name: 'HomeImageManagement',
    component: HomeImageManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/config',
    name: 'ConfigManagement',
    component: ConfigManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = isAdminLoggedIn()
  
  if (to.meta.requiresAuth && !isLoggedIn) {
    // 需要登录但未登录，跳转到登录页
    next('/login')
  } else if (to.path === '/login' && isLoggedIn) {
    // 已登录访问登录页，跳转到首页
    next('/admin')
  } else {
    next()
  }
})

export default router
